// idea from https://github.com/a8m/angular-filter
import { Pipe } from '@angular/core';
import { isString, isUndefined } from '../utils/utils';
var WrapPipe = (function () {
    function WrapPipe() {
    }
    WrapPipe.prototype.transform = function (input, wrap, ends) {
        return (isString(input) && !isUndefined(wrap)) ? [wrap, input, ends || wrap].join('') : input;
    };
    return WrapPipe;
}());
export { WrapPipe };
WrapPipe.decorators = [
    { type: Pipe, args: [{
                name: 'wrap'
            },] },
];
/** @nocollapse */
WrapPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=wrap.pipe.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-pipes/esm/string/wrap.pipe.js
// module id = 297
// module chunks = 103